import { sagas as customers } from 'logic/customers'
import { sagas as dates } from 'logic/dates'
import { sagas as events } from 'logic/events'
import { sagas as orders } from 'logic/orders'
import { sagas as orgs } from 'logic/orgs'
import { sagas as payment } from 'logic/payment'
import { sagas as seats } from 'logic/seats'
import { sagas as spl } from 'logic/spl'
import { sagas as vouchers } from 'logic/vouchers'
import { sagas as goods } from 'logic/goods'
import { sagas as sweetalert } from 'logic/sweetalert'
import { all, fork } from 'redux-saga/effects'

const collectedSagas = [
  customers,
  dates,
  events,
  goods,
  orders,
  orgs,
  payment,
  seats,
  spl,
  sweetalert,
  vouchers,
]

function* sagas() {
  const sagasForks = collectedSagas.map(saga => fork(saga));

  yield all([...sagasForks]);
}

export default sagas;
